import { Event } from "../../../../Global/Base/Events";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IContentBuilder } from "./IContentBuilder";

export enum CryptoOperationInProgress {
    signing,
    encryption,
    decription,
    finishingDecryption,
}

/**
 * @includeToDoc
 */
export class SignLayerBuilder implements IContentBuilder {
    private _element: HTMLElement;
    public openFileButtonClickEvent: Event<SignLayerBuilder, HTMLButtonElement> = new Event<SignLayerBuilder, HTMLButtonElement>();
    private _textElement: HTMLElement;
    private _iconElement: HTMLElement;
    private _operationInProgress: CryptoOperationInProgress;
    constructor(private showOpenButton: boolean = false, cryptoOpInProgress = CryptoOperationInProgress.signing) {
        //   this._element.appendChild(info);
        this._operationInProgress = cryptoOpInProgress;
    }

    private _createShowButton(): HTMLElement {
        const element = document.createElement("button");
        element.classList.add("OKButton", "primary", "btn", "btn-large", "flat", "sign-blocking-button");

        element.addEventListener("click", () => {
            if (element.classList.contains("Disabled"))
                return;
            this.openFileButtonClickEvent.trigger(this, element);
        });
        Localization.addLocData(element, "GUI-627313"); //Zobrazit podepisovaný soubor
        return element;
    }

    private async _buildLayoutInfo(): Promise<void> {
        if (!this._element) {
            const content = createElement({ classes: "sign-blocking-info" });
            this._iconElement = createElement({ classes: "icon sign-blocking-icon" });
            this._textElement = createElement({ classes: "sign-blocking-text" });

            await this.updateOperationInProgress(this._operationInProgress);
            content.appendChild(this._iconElement);
            content.appendChild(this._textElement);
            if (this.showOpenButton)
                content.appendChild(this._createShowButton());
            this._element = content;
        }
    }
    public async updateOperationInProgress(operation: CryptoOperationInProgress): Promise<void> {
        this._iconElement.classList.remove("editorial-pen");
        this._iconElement.classList.remove("user-lock-a");

        switch (operation) {
            case CryptoOperationInProgress.signing:
                Localization.addLocData(this._textElement, "GUI-628656"); //Probíhá podepisování, pokračujte v aplikaci Crypto Native App
                this._iconElement.classList.add("editorial-pen");
                break;
            case CryptoOperationInProgress.encryption:
                Localization.addLocData(this._textElement, "GUI-635174"); //Šifrujeme
                this._iconElement.classList.add("user-lock-a");
                break;
            case CryptoOperationInProgress.decription:
                Localization.addLocData(this._textElement, "GUI-635176"); //Probíhá dešifrování. Pokračujte v CryptoNativeApp
                this._iconElement.classList.add("user-lock-a");
                break;
            case CryptoOperationInProgress.finishingDecryption:
                Localization.addLocData(this._textElement, "GUI-635177"); //Dešifrujeme záznam
                this._iconElement.classList.add("user-lock-a");
                break;
        }
        this._operationInProgress = operation;
    }
    public async build(): Promise<HTMLElement> {
        await this._buildLayoutInfo();
        return this._element;
    }
}
